module.exports = __webpack_public_path__ + "static/media/sloth.4a88f174.svg";